import { useQuery } from '@tanstack/react-query';
import { getFailingMessages } from '../services/dashboard-api';
import type { EntityType, DocumentStatus } from '../types';

interface UseFailingMessagesOptions {
  limit?: number;
  offset?: number;
  entityType?: EntityType;
  status?: DocumentStatus;
  enabled?: boolean;
}

export function useFailingMessages(options: UseFailingMessagesOptions = {}) {
  const { limit = 100, offset = 0, entityType, status, enabled = true } = options;

  return useQuery({
    queryKey: ['failing-messages', limit, offset, entityType, status],
    queryFn: () => getFailingMessages({ limit, offset, entityType, status }),
    staleTime: 0, // Always fetch fresh data
    refetchInterval: 30000, // Refresh every 30 seconds
    enabled,
  });
}
